export const CARD_CONTAINER_CLASS = "m-1 lg:m-2 max-w-[302px]";
export const ARTIST_IMAGE_CONTAINER_CLASS =
    "h-[300px] xl:h-[440px] xl:w-[302px] object-cover border border-New_Primary_Default";
export const LOGO_IMAGE_CONTAINER_CLASS =
    "border border-t-0 w-full border-New_Primary_Default h-10 sm:h-15 object-contain";
